
import { defineComponent, PropType } from 'vue'
import { IssueDistributionT } from '~/types/reportTypes'
import { formatIntl, shortenLargeNumber, toSentenceCase } from '~/utils/string'
import { getIssueTypeIcon } from '~/utils/ui'

export default defineComponent({
  name: 'DistributionStatCard',
  props: {
    slug: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    logoUrl: {
      type: String,
      default: ''
    },
    statType: {
      type: String as PropType<IssueDistributionT>,
      default: IssueDistributionT.CATEGORY
    },
    linkCards: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    shortenLargeNumber,
    formatIntl,
    toSentenceCase,
    getIcon: getIssueTypeIcon,
    generateAnalyzerLink(slug?: string): string {
      return slug
        ? `${this.$generateRoute(['issues'])}?category=all&analyzer=${slug}`
        : `${this.$generateRoute(['issues'])}?category=all`
    },
    generateCategoryLink(slug?: string): string {
      return slug
        ? `${this.$generateRoute(['issues'])}?category=${slug}`
        : `${this.$generateRoute(['issues'])}`
    }
  },
  computed: {
    cardLink(): string | undefined {
      if (this.linkCards) {
        return this.statType === IssueDistributionT.ANALYZER
          ? this.generateAnalyzerLink(this.slug)
          : this.generateCategoryLink(this.slug)
      }
      return undefined
    }
  }
})
